init();

/**
 * Represents search method that would return true in case of element matches the condition.
 *
 * @callback ancestorCond
 * @param {Node} el - search element
 * @returns {bool} - match result or not.

*/
/**
 * Finds closest ancestor that matches the condition.
 *
 * @param {Node} el - starting point element.
 * @param {ancestorCond} cond - method that would trigger search to stop if true is returned.
 * @returns {?Node} - result of search.
 */
function findAncestor(el, cond, counter = 10) {
  let workingEl = el;

  let i = 0;
  while (workingEl) {
    if (i === counter) {
      return null;
    }

    if (cond(workingEl)) {
      return workingEl;
    }

    workingEl = workingEl.parentElement;
    i++;
  }

  return null;
}


function init() {
  const meta = document.querySelector('#shopify-features');
  if (!meta) {
    return;
  }

  let data;
  try {
    data = JSON.parse(meta.innerHTML);
  } catch (err) {
    window.console.log(err);
    return;
  }

  const shopID = data.shopId;

  document.addEventListener('click', async (event) => {
    const target = findAncestor(event.target, (el) => el.hasAttribute('data-add-to-wishlist'), 10);
    if (!target) {
      return;
    }

  	event.preventDefault();
    event.stopImmediatePropagation();

    if (target.classList.contains('js-blocked')) {
      return;
    }

  	const shopURL = target.getAttribute('data-shop-domain');
    if (!shopURL) {
      return;
    }

  	const productID = target.getAttribute('data-product-id');
    if (!productID) {
      return;
    }

  	const customerID = target.getAttribute('data-customer-id');
    if (!customerID) {
      return;
    }

  	target.classList.add('js-blocked');

    const added = target.classList.contains('js-added');
    try {
      await addToWishlist(shopID, shopURL, productID, customerID, added);
    } catch (err) {
      target.classList.remove('js-blocked');
      return;
    }

    if (added) {
      target.classList.remove('js-added');
    } else {
      target.classList.add('js-added');
    }

    target.classList.remove('js-blocked');
  });
}

function addToWishlist(shopID, shopURL, productID, customerID, remove) {
  const action = remove ? 'delete' : 'add';
  return window.fetch(`https://nourished-wishlist.sobi.design/v1/shop/${shopID}/customer/${customerID}`, {
    method: 'POST',
    mode: 'no-cors',
    body: JSON.stringify({
      shop_url: shopURL, // eslint-disable-line camelcase
      product_id: productID, // eslint-disable-line camelcase
      action,
    }),
    credentials: 'same-origin',
  });
}
